import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../AlertBox";
import { downloadRegisterPartnerInfra } from "../../api/projects";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";

export default function ModalDownloadRegistrationPartner({ show, onClose, onSuccess }) {
  const { projects } = useGroupListHooks();

  const [formFilter, setFormFilter] = useState({
    q: "",
    project_id: "",
  });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    resetFilter();
    onClose();
  };

  const resetFilter = () => {
    setFormFilter({
      q: "",
      project_id: "",
    });
  };

  const downloadFile = async () => {
    setLoading(true);

    try {
      let response = await downloadRegisterPartnerInfra({ ...formFilter });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Data Pendaftaran Provisioning.xlsx");
      onSuccess("Berhasil mengunduh Data Pendaftaran Provisioning.xlsx");
      document.body.appendChild(link);
      link.click();
      handleClose();
    } catch (error) {
      let message = "Something wrong ... ";

      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download Data Pendaftaran</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <form>
          <div className="form-group">
            <label htmlFor="query_search_download">Pencarian Nomor</label>
            <input
              type="text"
              name="query_search_download"
              value={formFilter.q}
              placeholder="Nama Pelanggan / No. Reg"
              onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
              className="form-control"
              id="query_search_download"
            />
          </div>
          <div className="form-group">
            <label htmlFor="projectFilterDownload">Grup/Project</label>
            <select
              className="form-control"
              id="projectFilterDownload"
              value={formFilter.project_id}
              onChange={(event) => setFormFilter({ ...formFilter, project_id: event.target.value })}
            >
              <option value="">SEMUA</option>
              {projects.map((project, index) => (
                <option value={project.id} key={index}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => handleClose()}>
          Close
        </button>
        <button className="btn btn-primary" onClick={() => downloadFile()} disabled={loading}>
          <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
